/**
 * SIREN et SIRET : la forme ET la clé (sixième relecture ARTO-51).
 *
 * Un numéro de quatorze chiffres n'est pas un SIRET : sa clé de Luhn doit
 * tomber juste. Sans elle, un SIRET inventé (« 73282932000000 ») laissait
 * déduire le SIREN d'une autre entité, et un avoir recomposait l'identité de
 * l'émetteur d'origine. Une seule fonction fait foi, partout : le profil
 * fiscal (entrée de l'API), le DTO des documents, et la déduction du SIREN.
 *
 * Exception documentée par l'INSEE : les établissements de La Poste (SIREN
 * 356000000) ont des SIRET qui ne respectent pas la clé de Luhn ; leur somme
 * des chiffres est un multiple de 5. Le siège (35600000000048), lui, respecte
 * la clé de Luhn : pour La Poste, l'une ou l'autre règle suffit.
 */
/** Le SIREN de La Poste, dont les SIRET suivent leur propre règle. */
export const SIREN_LA_POSTE = '356000000';
/** Vrai quand la suite de chiffres respecte la clé de Luhn. */
function cleDeLuhn(chiffres) {
    let somme = 0;
    for (let rang = 0; rang < chiffres.length; rang += 1) {
        let chiffre = Number(chiffres[chiffres.length - 1 - rang]);
        if (rang % 2 === 1) {
            chiffre *= 2;
            if (chiffre > 9)
                chiffre -= 9;
        }
        somme += chiffre;
    }
    return somme % 10 === 0;
}
/** Un SIREN valide : neuf chiffres, clé de Luhn juste. */
export function sirenValide(siren) {
    return /^\d{9}$/.test(siren) && cleDeLuhn(siren);
}
/**
 * Un SIRET valide : quatorze chiffres, un SIREN valide en tête, et la clé de
 * Luhn juste — ou, pour La Poste, une somme des chiffres multiple de 5.
 */
export function siretValide(siret) {
    if (!/^\d{14}$/.test(siret))
        return false;
    const siren = siret.slice(0, 9);
    if (!sirenValide(siren))
        return false;
    if (cleDeLuhn(siret))
        return true;
    if (siren !== SIREN_LA_POSTE)
        return false;
    const somme = [...siret].reduce((total, chiffre) => total + Number(chiffre), 0);
    return somme % 5 === 0;
}
//# sourceMappingURL=identifiants.js.map